import { useState, useEffect, useContext } from "react";
import React from "react";
// import { DataTable } from "primereact/datatable";
// import Loading from "../../components/Loading";
import Loading from "../Components/Loading.jsx";
import {
  FaEdit,
  FaTrash,
  FaEye,
  FaCalendarAlt,
  FaBars,
  FaBorderAll,
} from "react-icons/fa";
import { useLocation } from "react-router-dom";
// import { useUserContext } from '../context/DealerProfile.jsx'
// import { TfiMenuAlt } from "react-icons/tfi";
// import { Column } from "primereact/column";
import { Menu } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "../Context/UserProfile.jsx";
import { Link } from "react-router-dom";
import { AllStates } from "../Context/globalState.jsx";
import useSWR, { mutate } from "swr";
// import { Pagination } from "flowbite-react";
// Paste this once in your component file or extract to its own file

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const getPageNumbers = () => {
    const pages = [];
    const maxPagesToShow = 5;

    if (totalPages <= maxPagesToShow + 2) {
      // Show all pages if total is small
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      const left = Math.max(2, currentPage - 1);
      const right = Math.min(totalPages - 1, currentPage + 1);

      pages.push(1); // First page

      if (left > 2) pages.push('...'); // Left ellipsis

      for (let i = left; i <= right; i++) pages.push(i); // Middle pages

      if (right < totalPages - 1) pages.push('...'); // Right ellipsis

      pages.push(totalPages); // Last page
    }

    return pages;
  };

  const pages = getPageNumbers();

  return (
    <div className="flex flex-wrap justify-center items-center gap-2 mt-4 mr-[45px]">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Previous
      </button>

      {pages.map((page, index) =>
        page === '...' ? (
          <span key={index} className="px-3 py-1 text-gray-500">
            {page}
          </span>
        ) : (
          <button
            key={index}
            onClick={() => onPageChange(page)}
            className={`px-3 py-1 rounded hover:bg-gray-300 ${page === currentPage
              ? 'bg-blue-500 text-white'
              : 'bg-gray-200'
              }`}
          >
            {page}
          </button>
        )
      )}

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="px-3 py-1 rounded bg-gray-200 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Next
      </button>
    </div>
  );
};

export default function LeadsTable() {
  const { dealerDetail, error } = useUserContext();
  // const { allState, allStatedispatch } = useContext(AllStates);
  // const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  // const [leads, setLeads] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [openDropdown, setOpenDropdown] = useState(null); // Track open dropdown
  const [formData, setFormData] = useState({}); // Store lead form data
  const [editingId, setEditingId] = useState(null);
  const [tasks, setTasks] = useState([]);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  // Open modal
  // Open modal and save current state before changes
  const openModal = () => {
    setPrevSelectedColumns(selectedColumns); // Save current state before changes
    setIsModalOpen(true);
  };
  const [searchValues, setSearchValues] = useState({
    page: 1,
    limit: 10,
    dealerEmail: dealerDetail?.Email || "",
  });

  const columns = [
    // {
    //     name: (
    //         <div style={{

    //         }}
    //         >
    //             <FaBars
    //                 className="text-lg cursor-pointer hover:text-blue-500"
    //                 onClick={openModal}
    //             />
    //         </div>
    //     ),
    //     ignoreRowClick: true,
    //     allowOverflow: true,
    //     button: true,
    // },

    // {
    //     name: (
    //         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
    //             Action
    //         </div>
    //     ),
    //     cell: rowData => actionTemplate(rowData),
    //     ignoreRowClick: true,
    //     allowOverflow: true,
    //     button: true,
    // },
    {
      name: "Contact Name",
      selector: (row) => (
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: "#5A5A5C",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.target.style.color = "blue")}
          onMouseLeave={(e) => (e.target.style.color = "#5A5A5C")}
          onClick={() => navigate(`/Vendor-details/${row.id}`)}
        >
          {row?.Name}
        </span>
      ),
      sortable: true,
      wrap: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "200px",
    },
    {
      name: "Email",
      selector: (row) => (
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: "#5A5A5C",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.target.style.color = "blue")}
          onMouseLeave={(e) => (e.target.style.color = "#5A5A5C")}
          onClick={() => navigate(`/vendor-details/${row.id}`)}
        >
          {row?.Vendor_Email}
        </span>
      ),
      sortable: true,
      wrap: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "200px",
    },

    {
      name: "Request Type",
      selector: (row) => (
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: "#5A5A5C",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.target.style.color = "blue")}
          onMouseLeave={(e) => (e.target.style.color = "#5A5A5C")}
          onClick={() => navigate(`/vendor-details/${row.id}`)}
        >
          {row?.Request_Type}
        </span>
      ),
      sortable: true,
      wrap: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "200px",
    },
    {
      name: "Request Status ",
      selector: (row) => (
        <span
          style={{
            fontSize: 16,
            cursor: "pointer",
            color: "#5A5A5C",
            transition: "color 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.target.style.color = "blue")}
          onMouseLeave={(e) => (e.target.style.color = "#5A5A5C")}
          onClick={() => navigate(`/vendor-details/${row.id}`)}
        >
          {row?.Request_Status}
        </span>
      ),
      sortable: true,
      wrap: true,
      style: { fontSize: 16, color: "#5A5A5C" },
      minWidth: "200px",
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [selectedColumns, setSelectedColumns] = useState(columns.map(col => col.name)); // Default: Show all columns
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedColumns, setSelectedColumns] = useState([]);

  // State to track the most recently clicked column
  const [lastClickedColumn, setLastClickedColumn] = useState(null);
  const [initialColumns, setInitialColumns] = useState([]); // Track initial columns state

  // Fetch columns from localStorage or default columns when component mounts
  useEffect(() => {
    const storedColumns = localStorage.getItem("selectedColumns");

    if (storedColumns) {
      // If columns are found in localStorage, use them
      const parsedColumns = JSON.parse(storedColumns);
      setSelectedColumns(parsedColumns);
      setInitialColumns(parsedColumns); // Save the initial state
    } else {
      // Otherwise, use default columns (this is assuming 'columns' is your default set)
      const defaultColumns = columns.map((col) => col.name);
      setSelectedColumns(defaultColumns);
      setInitialColumns(defaultColumns); // Save the initial state
    }
  }, []);

  // Function to handle column changes
  const handleColumnChange = (colName) => {
    setSelectedColumns((prev) => {
      const updatedColumns = prev.includes(colName)
        ? prev.filter((name) => name !== colName)
        : [...prev, colName];

      try {
        // Ensure only primitive values (strings) are stored
        const safeColumns = updatedColumns.map((col) => String(col));
        localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
      } catch (error) {
        console.error("Error saving to localStorage:", error);
      }

      // Track the most recent checkbox clicked
      setLastClickedColumn(colName);

      return updatedColumns;
    });
  };

  // Function to apply filters (save to localStorage)
  const applyFilter = () => {
    try {
      // Ensure only primitive values (strings) are stored
      const safeColumns = selectedColumns.map((col) => String(col));
      localStorage.setItem("selectedColumns", JSON.stringify(safeColumns));
    } catch (error) {
      console.error("Error saving to localStorage:", error);
    }

    setIsModalOpen(false);
  };

  const [prevSelectedColumns, setPrevSelectedColumns] = useState([]); // Store previous state

  // Function to reset filter by restoring the saved state
  const resetFilter = () => {
    setSelectedColumns(prevSelectedColumns); // Restore previous selection
    setIsModalOpen(false);
  };

  const filteredColumns = columns.filter(
    (col) => selectedColumns.includes(col.name) || typeof col.name === "object"
  );

  const [isFetched, setIsFetched] = useState(false);





  // useEffect(() => {
  //   fetchLeads({
  //     contact: contactFilter,
  //     requestStage: requestStageFilter,
  //     requestStatus: requestStatusFilter,
  //     requestType: requestTypeFilter,
  //   });
  // }, []); // run once on component mount

  // const fetchLeads = async ({
  //   contact = "",
  //   requestStage = "",
  //   requestStatus = "",
  //   requestType = "",
  //   page = currentPage,
  //   limit = rowsPerPage,
  // } = {}) => {
  //   setIsLoading(true);
  //   try {
  //     const response = await fetch("/server/dealer_backend/getAllTickets", {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         dealerEmail: dealerDetail?.Email,
  //         contact,
  //         requestStage,
  //         requestStatus,
  //         requestType,
  //         page,
  //         limit,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (data.status === "success") {
  //       setLeads(data.data || []);
  //       setTotalPages(data.pagination?.totalPages || 1);
  //       setTotalRecords(data.pagination?.totalRecords || 0);
  //     } else {
  //       setLeads([]);
  //       setTotalPages(1);
  //       setTotalRecords(0);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching leads:", error);
  //     setLeads([]);
  //     setTotalPages(1);
  //     setTotalRecords(0);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };





  const location = useLocation();

  // ----------------------
  // Load filters from localStorage when component mounts
  // ----------------------
  const [contactFilter, setContactFilter] = useState(
    localStorage.getItem("contactFilter") || ""
  );
  const [requestStageFilter, setRequestStageFilter] = useState(
    localStorage.getItem("requestStageFilter") || ""
  );
  const [requestStatusFilter, setRequestStatusFilter] = useState(
    localStorage.getItem("requestStatusFilter") || ""
  );
  const [requestTypeFilter, setRequestTypeFilter] = useState(
    localStorage.getItem("requestTypeFilter") || ""
  );

  const [requestNumberFilter, setRequestNumberFilter] = useState(
    localStorage.getItem("requestNumberFilter") || ""
  );

  // ----------------------
  // Applied filters (merged into a single state object)
  // ----------------------

  const [contactFilterId, setContactFilterId] = useState("");   // ID for backend
  const [contactFilterName, setContactFilterName] = useState(""); // Name for UI

  // ✅ "Applied" filters — what actually gets sent to API
  const [appliedFilters, setAppliedFilters] = useState({
    contactFilter,
    requestStageFilter,
    requestStatusFilter,
    requestTypeFilter,
    requestNumberFilter,
    contactFilterId,
    contactFilterName,
  });


  
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  // ----------------------
  // Sync → localStorage whenever filters change
  // ----------------------

  useEffect(() => {
    localStorage.setItem("contactFilter", contactFilter);
  }, [contactFilter]);

  useEffect(() => {
    localStorage.setItem("requestStageFilter", requestStageFilter);
  }, [requestStageFilter]);

  useEffect(() => {
    localStorage.setItem("requestStatusFilter", requestStatusFilter);
  }, [requestStatusFilter]);

  useEffect(() => {
    localStorage.setItem("requestTypeFilter", requestTypeFilter);
  }, [requestTypeFilter]);

  useEffect(() => {
    localStorage.setItem("requestNumberFilter", requestNumberFilter);
  }, [requestNumberFilter]);

  useEffect(() => {
    const savedContactFilter = localStorage.getItem("contactFilter") || "";
    const savedContactFilterName = localStorage.getItem("contactFilterName") || "";

    setContactFilter(savedContactFilter);

    if (savedContactFilterName) {
      setContactFilterName(savedContactFilterName);
    } else if (savedContactFilter && suggestions.length > 0) {
      const matched = suggestions.find((s) => s.id === savedContactFilter);
      if (matched) setContactFilterName(matched.name);
    }
  }, [suggestions]);

  // Save contact filter ID and name whenever they change
  useEffect(() => {
    localStorage.setItem("contactFilter", contactFilter);
    localStorage.setItem("contactFilterName", contactFilterName);
  }, [contactFilter, contactFilterName]);


  // ----------------------
  // Fetcher utility
  // ----------------------
  const postFetcher = (url, body) =>
    fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }).then((res) => {
      if (!res.ok) throw new Error("Failed to fetch");
      return res.json();
    });

  function useLeads(params) {
    const key = params ? ["/server/dealer_backend/getAllTickets", params] : null;

    const { data, error, isLoading } = useSWR(
      key,
      ([url, body]) => postFetcher(url, body),
      {
        revalidateOnFocus: false,
        keepPreviousData: true,
      }
    );

    return {
      leads: data?.data || [],
      pagination: data?.pagination || {},
      isLoading,
      totalRecords: data?.pagination?.totalRecords || 0,
      isError: error,
      refresh: () => mutate(key),
    };
  }

  // ✅ Hook fetches with appliedFilters
  const { leads, pagination, totalRecords, isLoading, isError, refresh } = useLeads({
    page: searchValues.page,
    limit: searchValues.limit,
    dealerEmail: dealerDetail?.Email,
    ...appliedFilters,
  });



  const totalPages = Math.ceil(leads.length / rowsPerPage);
  const onPageChange = (page) => setCurrentPage(page);
  const handleRowsPerPageChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleView = (rowData, field) => {
    navigate(`/owner-details/${rowData.id}`);
  };

  const handleEditClick = async (rowData) => {
    // setFormData(rowData); // Populate form with existing data before editing
    // setEditingId(rowData.id); // Store the ID of the lead being edited
    navigate(`/lead-edit/${rowData.id}`);
  };

  const actionTemplate = (rowData) => (
    <div className="flex gap-2">
      <button
        className="text-blue-500"
        onClick={() => handleView(rowData, "Owner")}
      >
        <FaEye />
      </button>
      {/* <button className="text-green-500" onClick={() => handleEditClick(rowData)}>
                <FaEdit />
            </button> */}

      {/* <button className="text-red-500" onClick={() => console.log("Delete", rowData.id)}>
                <FaTrash />
            </button> */}
    </div>
  );


  const fetcher = (url) =>
    fetch(url).then(async (res) => {
      if (!res.ok) throw new Error("Failed to fetch");
      const result = await res.json();
      if (result.status !== "success") throw new Error(result.error || "API error");
      return result.data || [];
    });

  function usePicklist(fieldId) {
    const key = fieldId
      ? `/server/dealer_backend/getPickListValues/${fieldId}?module=Logistic_Request&type=used`
      : null;

    const { data, error, isLoading } = useSWR(key, fetcher, {
      revalidateOnFocus: false, // prevent refetch every tab switch
    });

    return {
      options: data || [],
      isLoading,
      isError: error,
    };
  }






  useEffect(() => {
    if (!contactFilter) {
      setSuggestions([]);
      return;
    }

    const handler = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await fetch(`/server/dealer_backend/getAllAccounts?search=${encodeURIComponent(contactFilter)}`);
        const data = await res.json();
        setSuggestions(data.data || []);
      } catch (err) {
        console.error("Error fetching accounts:", err);
      } finally {
        setLoading(false);
      }
    }, 400); // debounce 400ms

    return () => clearTimeout(handler);
  }, [contactFilter]);
  // const { options: requestStageOptions, isLoading: stageLoading } =
  //   usePicklist("4716167000191137706");

  const { options: requestStatusOptions, isLoading: statusLoading } =
    usePicklist("4716167000190108734");

  const { options: requestTypeOptions, isLoading: typeLoading } =
    usePicklist("4716167000190108278");



  const handleApplyFilters = () => {
    setAppliedFilters({
      contactFilter,
      requestStageFilter,
      requestStatusFilter,
      requestTypeFilter,
      requestNumberFilter,
    });
    setSearchValues((prev) => ({ ...prev, page: 1 })); // Reset page
  };








  // ✅ Clear button handler
  const handleClearFilters = () => {
    // Reset UI state
    setContactFilter("");
    setRequestStageFilter("");
    setRequestStatusFilter("");
    setRequestTypeFilter("");
    setRequestNumberFilter("");
    setContactFilterId("");
    setContactFilterName("");
    // Reset applied filters
    setAppliedFilters({
      contactFilter: "",
      requestStageFilter: "",
      requestStatusFilter: "",
      requestTypeFilter: "",
      requestNumberFilter: "",
      contactFilterId: "",
      contactFilterName: "",
    });

    // Reset pagination
    setSearchValues({ page: 1, limit: searchValues.limit });

    // Clear from localStorage
    localStorage.removeItem("contactFilter");
    localStorage.removeItem("requestStageFilter");
    localStorage.removeItem("requestStatusFilter");
    localStorage.removeItem("requestTypeFilter");
    localStorage.removeItem("requestNumberFilter");
    localStorage.removeItem("contactFilterId");
    localStorage.removeItem("contactFilterName");
    localStorage.removeItem("page"); // optional, if you want
  };








  return (
    <div className="p-6 space-y-6 text-gray-800">
      {/* Manage Columns Modal */}
      {isModalOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setIsModalOpen(false)}
          aria-modal="true"
          role="dialog"
          aria-labelledby="manage-columns-title"
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-sm w-full p-6"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 id="manage-columns-title" className="text-xl font-bold mb-5">
              Manage Columns
            </h2>

            {/* Search Input */}
            <input
              type="text"
              placeholder="Search columns..."
              className="w-full p-2 border border-gray-300 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              aria-label="Search columns"
            />

            {/* Column List with Scroll */}
            <div className="max-h-60 overflow-auto border border-gray-200 rounded p-3">
              {columns
                .filter((col) => typeof col.name === "string")
                .filter((col) =>
                  col.name.toLowerCase().includes(searchTerm.toLowerCase())
                )
                .map((col, index) => {
                  const isLastName = col.name === "Last Name";
                  return (
                    <label
                      key={index}
                      className={`flex items-center mb-3 cursor-pointer select-none ${isLastName
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:text-blue-600"
                        }`}
                    >
                      <input
                        type="checkbox"
                        className="mr-3"
                        disabled={isLastName}
                        checked={selectedColumns.includes(col.name)}
                        onChange={() =>
                          !isLastName && handleColumnChange(col.name)
                        }
                      />
                      <span>{col.name}</span>
                    </label>
                  );
                })}
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={resetFilter}
                className="px-5 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={applyFilter}
                className="px-5 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Table header */}
      <div className="flex justify-between items-center px-2 md:px-6 mb-4">
        {/* Manage Columns Button */}
        <div className="relative group hidden md:inline-flex">
          <button
            onClick={openModal}
            type="button"
            className="p-2 bg-white shadow rounded-md hover:text-blue-600 transition text-blue-500"
            aria-label="Manage columns"
          >
            <Menu className="text-xl" />
          </button>
          <div
            className="absolute left-1/2 -translate-x-1/2 top-full mt-2 bg-gray-800 text-white text-xs rounded px-2 py-1 shadow-md opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap z-10"
            role="tooltip"
          >
            Manage Columns
          </div>
        </div>

        {/* 🔹 Filters Section */}
        {/* 🔹 Filters UI */}




        {/* Add Lead Button - Uncomment if needed */}
        {/* <button
        onClick={() => navigate("/create-lead")}
        className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition"
      >
        Add Lead
      </button> */}
      </div>

      <div className="rounded-md px-4 py-3 mb-4 flex flex-wrap items-end gap-4 ">

        {/* Contact Name */}
        <div className="flex flex-col relative">
          <label htmlFor="contactFilter" className="text-gray-800 text-sm font-medium mb-1">
            Project Name
          </label>
          <input
            id="contactFilter"
            type="text"
            value={contactFilterName}
            placeholder="Enter project name"
            onChange={(e) => {
              setContactFilter(e.target.value);
              setContactFilterName(e.target.value);
              setShowSuggestions(true); // show suggestions as user types
            }}
            className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring-2
 focus:ring-blue-400 transition bg-white w-56 pr-7"
          />

          {suggestions.length > 0 && showSuggestions && (
            <ul className="absolute top-[60px] left-0 bg-white border border-gray-300 rounded w-56 max-h-40 overflow-y-auto shadow-md z-10">
              {suggestions.map((s) => (
                <li
                  key={s.id}
                  onClick={() => {
                    setContactFilter(s.id);
                    setContactFilterName(s.name);
                    setShowSuggestions(false);  // hide dropdown after selecting
                  }}
                  className="px-3 py-2 text-sm hover:bg-blue-100 cursor-pointer"
                >
                  {s.name}
                </li>
              ))}
            </ul>
          )}

        </div>

        {/* Request Stage */}
        {/* <div className="flex flex-col">
          <label htmlFor="requestStageFilter" className="text-gray-800 text-sm font-medium mb-1">
            Request Stage
          </label>
          <select
            id="requestStageFilter"
            value={requestStageFilter}
            onChange={(e) => {
              setRequestStageFilter(e.target.value);
              setCurrentPage(1);
            }}
            className="border border-gray-300 rounded px-3 py-1.5 text-sm 
                 focus:ring-2 focus:ring-blue-400 transition bg-white w-48"
          >
            <option value="">All</option>
            {requestStageOptions?.map((option, idx) => (
              <option key={idx} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div> */}

        {/* Request Status */}
        <div className="flex flex-col">
          <label htmlFor="requestStatusFilter" className="text-gray-800 text-sm font-medium mb-1">
            Request Status
          </label>
          <select
            id="requestStatusFilter"
            value={requestStatusFilter}
            onChange={(e) => {
              setRequestStatusFilter(e.target.value);
              setCurrentPage(1);
            }}
            className="border border-gray-300 rounded px-3 py-1.5 text-sm 
                 focus:ring-2 focus:ring-blue-400 transition bg-white w-48"
          >
            <option value="">All</option>
            {requestStatusOptions?.map((option, idx) => (
              <option key={idx} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Request Type */}
        <div className="flex flex-col">
          <label htmlFor="requestTypeFilter" className="text-gray-800 text-sm font-medium mb-1">
            Request Type
          </label>
          <select
            id="requestTypeFilter"
            value={requestTypeFilter}
            onChange={(e) => {
              setRequestTypeFilter(e.target.value);
              setCurrentPage(1);
            }}
            className="border border-gray-300 rounded px-3 py-1.5 text-sm 
                 focus:ring-2 focus:ring-blue-400 transition bg-white w-48"
          >
            <option value="">All</option>
            {requestTypeOptions?.map((option, idx) => (
              <option key={idx} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>

        {/* Request Number */}
        <div className="flex flex-col">
          <label htmlFor="requestNumberFilter" className="text-gray-800 text-sm font-medium mb-1">
            Request Number
          </label>
          <input
            id="requestNumberFilter"
            type="text"
            value={requestNumberFilter}
            placeholder="Enter request number"
            onChange={(e) => {
              setRequestNumberFilter(e.target.value);
              setCurrentPage(1); // optional: reset page if using pagination
            }}
            className="border border-gray-300 rounded px-3 py-1.5 text-sm focus:ring-2
    focus:ring-blue-400 transition bg-white w-48"
          />
        </div>


        {/* Action Buttons */}
        <div className="flex gap-4 ml-auto mt-6 sm:mt-0">

          <button
            className="bg-gray-100 hover:bg-gray-300 text-gray-800 font-semibold px-3 py-1.5 rounded-md shadow focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-1 border border-gray-300 transition"
            onClick={handleClearFilters}
          >
            Clear Filters
          </button>



          <button
            onClick={handleApplyFilters}
            className="bg-[#2070B9] hover:bg-blue-700 text-white font-semibold px-3 py-1.5 rounded-md shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1 transition"
            aria-label="Apply filters"
          >
            Apply Filters
          </button>

        </div>

      </div>

      {/* Loading State */}
      {isLoading ? (
        <div
          className="flex justify-center items-center gap-3 py-10 text-blue-600"
          role="status"
          aria-live="polite"
        >
          <svg
            className="animate-spin h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
            />
          </svg>
          Loading Data...
        </div>
      ) : leads.length === 0 ? (
        <div className="text-center py-10 text-blue-600 font-medium">
          No data available
        </div>
      ) : (
        <>
          {/* DataTable */}
          <div className="overflow-auto max-w-full rounded-lg shadow border border-gray-200">
            <table className="w-full border-collapse text-lg">
              <thead className="bg-gray-100">
                <tr>
                  {filteredColumns.map((col, index) => (
                    <th
                      key={index}
                      className="px-4 py-2 text-left text-gray-700 font-semibold border-b"
                    >
                      {col.name}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {leads
                  .slice(
                    (currentPage - 1) * rowsPerPage,
                    currentPage * rowsPerPage
                  )
                  .map((row, rowIndex) => (
                    <tr
                      key={rowIndex}
                      className="hover:bg-gray-50 border-b last:border-none"
                    >
                      {filteredColumns.map((col, colIndex) => (
                        <td
                          key={colIndex}
                          className="px-4 py-2 whitespace-nowrap"
                        >
                          {typeof col.selector === "function"
                            ? col.selector(row)
                            : row[col.selector]}
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          <div className="mt-4 flex flex-wrap justify-between items-center gap-4 px-2">
            <span className="text-gray-700 select-none">
              {`Fetched ${totalRecords} entries`}
            </span>

            <div className="flex items-center gap-2">
              <label htmlFor="recordsPerPage" className="text-gray-700 font-medium select-none">
                Records per page:
              </label>
              <select
                id="recordsPerPage"
                value={searchValues.limit}
                onChange={(e) =>
                  setSearchValues((prev) => ({
                    ...prev,
                    limit: Number(e.target.value),
                    page: 1,
                  }))
                }
                className="border border-gray-300 rounded px-2 py-1 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 transition"
              >
                {[10, 25, 50, 100].map((n) => (
                  <option key={n} value={n}>
                    {n}
                  </option>
                ))}
              </select>
            </div>

            <Pagination
              currentPage={searchValues.page}
              totalPages={Math.ceil(totalRecords / searchValues.limit)}
              onPageChange={(page) =>
                setSearchValues((prev) => ({ ...prev, page }))
              }
            />

          </div>
        </>
      )}
    </div>
  );
}